import { render, staticRenderFns } from "./user-assets.vue?vue&type=template&id=1ac19537&scoped=true"
import script from "./user-assets.vue?vue&type=script&lang=js"
export * from "./user-assets.vue?vue&type=script&lang=js"
import style0 from "./user-assets.vue?vue&type=style&index=0&id=1ac19537&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac19537",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ac19537')) {
      api.createRecord('1ac19537', component.options)
    } else {
      api.reload('1ac19537', component.options)
    }
    module.hot.accept("./user-assets.vue?vue&type=template&id=1ac19537&scoped=true", function () {
      api.rerender('1ac19537', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/components/user-assets.vue"
export default component.exports